
export const generateKey = () => {
    return Math.random().toString(16).slice(2)
};
